export default __webpack_public_path__ + "assets/howToImport3.0c8732c5.gif";